import { render, staticRenderFns } from "./MentionList.vue?vue&type=template&id=662c9363&lang=pug"
import script from "./MentionList.vue?vue&type=script&lang=ts"
export * from "./MentionList.vue?vue&type=script&lang=ts"
import style0 from "./MentionList.vue?vue&type=style&index=0&id=662c9363&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports